export class DayNightCycle {
  constructor(game) {
    this.game = game
    
    this.cycleLength = 600 // 10 minutes in seconds
    this.currentTime = 0.35 // Start at morning (0 = midnight, 0.5 = noon)
    
    this.phases = {
      NIGHT: 'Night',
      DAWN: 'Dawn',
      DAY: 'Day',
      DUSK: 'Dusk'
    }
  }
  
  update(delta) {
    this.currentTime += delta / this.cycleLength
    if (this.currentTime >= 1) this.currentTime -= 1
  }
  
  getPhase() {
    if (this.currentTime >= 0.2 && this.currentTime < 0.3) return this.phases.DAWN
    if (this.currentTime >= 0.3 && this.currentTime < 0.7) return this.phases.DAY
    if (this.currentTime >= 0.7 && this.currentTime < 0.8) return this.phases.DUSK
    return this.phases.NIGHT
  }
  
  isNight() {
    return this.currentTime < 0.2 || this.currentTime >= 0.8
  }
  
  isDawn() {
    return this.currentTime >= 0.2 && this.currentTime < 0.3
  }
  
  isDay() {
    return this.currentTime >= 0.3 && this.currentTime < 0.7
  }
  
  isDusk() {
    return this.currentTime >= 0.7 && this.currentTime < 0.8
  }
  
  getEnemyDamageMultiplier() {
    return this.isNight() ? 1.25 : 1.0
  }
  
  getEnemySpawnMultiplier() {
    return this.isNight() ? 2.0 : 1.0
  }
  
  // Get background color based on time
  getBackgroundColor() {
    if (this.isNight()) return '#1a1a2e'
    if (this.isDawn()) return '#4a3a50'
    if (this.isDusk()) return '#5a3a40'
    return '#3a5a3a' // Day - green tinted
  }
  
  // Get overlay for darkness effect
  getOverlay() {
    if (this.isNight()) {
      return { color: '#000033', alpha: 0.4 }
    }
    if (this.isDawn() || this.isDusk()) {
      return { color: '#ff6600', alpha: 0.1 }
    }
    return null // No overlay during day
  }
  
  serialize() {
    return { currentTime: this.currentTime }
  }
  
  deserialize(data) {
    if (data) {
      this.currentTime = data.currentTime || 0.35
    }
  }
  
  load(data) {
    this.deserialize(data)
  }
}
